export const css = {
	statusIcon: '_20RQiSTa',
	badgeStatusIcon: '_12ToDlFU',
	statusNotDone: '_3w_GIByW',
	statusComplete: 'E1AkaSSR',
	statusInProgress: '_1ukvZnMA',
	' _key': 'apic-theme/apic/book-widgets/status-icon'
};

export default css;
